import subBanner from '@/assets/img/banner_bg_2@2x.png'


// 海报
import banner1 from '@/assets/img/banner_bg@2x.png'
import banner2 from '@/assets/img/banner2_bg@2x.png'
import banner3 from '@/assets/img/banner5_bg@2x.png'

const bannerConf = [
    {
        title: '中科德诺 · 物联网低功耗微传感芯片SoC',
        subTitle: 'DNG · AIoT SoC .',
        slogan: '— 一家人工智能物联网传感企业 —',
        src: banner3
    },
    {
        title: '中科德诺·智慧社区领航者',
        subTitle: 'DNG·The smart community leader.',
        slogan: '— 这一刻，让美好生活更简单 —',
        src: banner1
    },
    {
        title: '中科德诺·人脸识别',
        subTitle: 'DNG·Face recoginition',
        slogan: '— 这一刻，解放双手享受科技的美好 —',
        src: banner2
    },

]


// 合作伙伴logo
import iconPartner1 from '@/assets/img/Partner1@2x.png'
import iconPartner2 from '@/assets/img/Partner2@2x.png'
import iconPartner3 from '@/assets/img/Partner3@2x.png'
import iconPartner4 from '@/assets/img/Partner4@2x.png'
import iconPartner5 from '@/assets/img/Partner5@2x.png'
import iconPartner6 from '@/assets/img/Partner6@2x.png'
import iconPartner7 from '@/assets/img/Partner7@2x.png'
import iconPartner8 from '@/assets/img/Partner8@2x.png'
import iconPartner9 from '@/assets/img/Partner9@2x.png'
import iconPartner10 from '@/assets/img/Partner10@2x.png'
import iconPartner11 from '@/assets/img/Partner11@2x.png'
import iconPartner12 from '@/assets/img/Partner12@2x.png'
import iconPartner13 from '@/assets/img/Partner13@2x.png'
import iconPartner14 from '@/assets/img/Partner14@2x.png'
import iconPartner15 from '@/assets/img/Partner15@2x.png'
import iconPartner16 from '@/assets/img/Partner16@2x.png'
import iconPartner17 from '@/assets/img/Partner17@2x.png'
import iconPartner18 from '@/assets/img/Partner18@2x.png'
import iconPartner19 from '@/assets/img/Partner19@2x.png'
import iconPartner20 from '@/assets/img/Partner20@2x.png'


const partners = [

    iconPartner1,
    iconPartner2,
    iconPartner3,
    iconPartner4,
    iconPartner5,
    iconPartner6,
    iconPartner7,
    iconPartner8,
    iconPartner9,
    iconPartner10,
    iconPartner11,
    iconPartner12,
    iconPartner13,
    iconPartner14,
    iconPartner15,
    iconPartner16,
    iconPartner17,
    iconPartner18,
    iconPartner19,
    iconPartner20,

]


// 解决方案icon
import iconDoor from '@/assets/img/icon_door@2x.png'
import iconFace from '@/assets/img/icon_face@2x.png'
import iconCar from '@/assets/img/icon_car@2x.png'
import iconLight from '@/assets/img/icon_light@2x.png'
import iconHome from '@/assets/img/icon_home@2x.png'
import iconRepair from '@/assets/img/icon_repair@2x.png'
import iconCharge from '@/assets/img/icon_charge@2x.png'
import iconEnvironmental from '@/assets/img/icon_environmental@2x.png'

const scheme = [
    {
        icon: iconDoor,
        title: '智慧门禁',
        content: `支持自助式访客管理、支持刷卡、密码、身份证、人脸识别、虹膜、指纹、蓝牙、手机APP等多种开门方式。`
    },
    {
        icon: iconFace,
        title: '人脸识别',
        content: `通过门禁系统对抓拍到人脸图像、车辆信息进行实时监控，从而提升安防管控。`
    },
    {
        icon: iconCar,
        title: '智慧车辆管理',
        content: `实现所有停车场的集中管控：数据联网、车位引导和手机车位预定、无感支付、寻车等功能。`
    },
    {
        icon: iconLight,
        title: '智慧路灯',
        content: `可以通过远程、实时、预设等模式了解路况、无线WIFI连接、智能充电、一键报警等易纲多功能。`
    },
    {
        icon: iconHome,
        title: '智慧家居',
        content: `含有智能灯光、智能门窗、智能语音、智能门锁、智能安防、智能睡眠等智能家电配套产品。`
    },
    {
        icon: iconRepair,
        title: '智慧物业管理',
        content: `通过云平台实现移动物管、财务管理、人力资源管理、住户管理、物业账单、物业公告、投诉和物业报修。`
    },
    {
        icon: iconCharge,
        title: '智慧充电桩',
        content: `实现对电动车充电的管理、计费和相应的电池状态监测和自动化充电过程的监控及安防。`
    },
    {
        icon: iconEnvironmental,
        title: '智慧环保',
        content: `通过网络覆盖实现环保信息发布管理、生活垃圾分类管理、环境质量自动监测监控、自来水在线监测等。`
    },

];


// 经典案例图片
import bus from '@/assets/img/公交bg@2x.png'
import classroom from '@/assets/img/课堂bg@2x.png'
import streetLamp from '@/assets/img/路灯bg@2x.png'
import community from '@/assets/img/社区bg@2x.png'
import medicalTreatment from '@/assets/img/医疗bg@2x.png'
import waterAffairs from '@/assets/img/水务bg@2x.png'


const cases = [
    [
        {
            type: 'half',
            src: community,
            title: '智慧社区',
            url: '/'
        },
        {
            type: 'half',
            src: waterAffairs,
            title: '智慧水务',
            url: '/'
        },

    ],
    [
        {
            type: 'half',
            src: classroom,
            title: '智慧校园',
            url: '/'
        },
        {
            type: 'half',
            src: bus,
            title: '智慧公交',
            url: '/'
        }
    ],
    [
        {
            type: 'half',
            src: medicalTreatment,
            title: '智慧医疗',
            url: '/'
        },
        {
            type: 'half',
            src: streetLamp,
            title: '智慧路灯',
            url: '/'
        },

    ],

]

export {
    subBanner,
    bannerConf,
    partners,
    scheme,
    cases,
}

